import { ChangeEvent, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  list: {
    margin: 0,
    paddingLeft: 0,
    listStyleType: 'none',
  },
}));

type Option<T> = {
  key: string | number;
  value: T;
  label: string;
};

interface RadioInputProps<T> {
  id?: string;
  name?: string;
  ariaLabel?: string;
  options: Option<T>[];
  defaultValue?: T | undefined;
  error?: string[];
  required?: boolean;
  disabled?: boolean;
  onValueChange?: (value: T | undefined) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const RadioList = <T extends string | number>(props: RadioInputProps<T>) => {
  const { onChange, onValueChange } = props;

  const classes = useStyles();

  const [value, setValue] = useState<T | undefined>(props.defaultValue);

  const handleValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    const pattern = new RegExp('^[0-9]+$');
    const newValue = pattern.test(event.target.value)
      ? parseInt(event.target.value, 10)
      : event.target.value;
    setValue(newValue as T);
    onChange?.(event);
  };

  useEffect(() => {
    onValueChange?.(value);
  }, [value, onValueChange]);

  return (
    <div>
      <ul id={props.id} className={classes.list}>
        {props.options.map((option) => {
          return (
            <li key={option.key}>
              <input
                type="radio"
                id={`option-${props.id}-${option.key}`}
                name={props.name}
                value={option.value}
                checked={value === option.value}
                required={props.required}
                disabled={props.disabled}
                onChange={handleValueChange}
              />
              <label htmlFor={`option-${props.id}-${option.key}`}>
                {option.label}
              </label>
            </li>
          );
        })}
      </ul>
      {props.error && <div>{props.error[0]}</div>}
    </div>
  );
};

export default RadioList;
